import { useState } from 'react'

import styles from './StakingToggle.module.scss'

interface StakingToggleProps {
  onChange: (value: 'stake' | 'unstake') => void
}

export default function StakingToggle({ onChange }: StakingToggleProps) {
  const [selected, setSelected] = useState<'stake' | 'unstake'>('stake')

  const handleSelected = (value: 'stake' | 'unstake') => {
    setSelected(value)
    onChange(value)
  }

  return (
    <div className={styles.toggle}>
      <input
        checked={selected === 'stake'}
        id="stake"
        name="toggle"
        onChange={() => handleSelected('stake')}
        type="radio"
        value="stake"
      />
      <input
        checked={selected === 'unstake'}
        id="unstake"
        name="toggle"
        onChange={() => handleSelected('unstake')}
        type="radio"
        value="unstake"
      />
      <label
        className={`${styles.toggle__item} ${selected === 'stake' ? styles['toggle__item--active'] : ''}`}
        htmlFor="stake"
      >
        Stake
      </label>
      <label
        className={`${styles.toggle__item} ${selected === 'unstake' ? styles['toggle__item--active'] : ''}`}
        htmlFor="unstake"
      >
        Unstake
      </label>
    </div>
  )
}
